let apiBase = {
  queryList: '/api/identifyApkBlacklist/queryPage', // 列表
  addBlack: '/api/identifyApkBlacklist/add', // 新增
  deleteBlack: '/api/identifyApkBlacklist/delete', // 删除
  exportBlacklist: '/api/identifyApkBlacklist/export', // 导出
}
let singleServerObject = null
class BlackServer {
  constructor() {}
  queryList(data = {}) {
    return $http({
      url: apiBase.queryList,
      method: 'post',
      data: data,
    })
  }
  addBlack(data = {}) {
    return $http({
      url: apiBase.addBlack,
      method: 'post',
      data: data,
    })
  }
  deleteBlack(data = {}) {
    return $http({
      url: apiBase.deleteBlack,
      method: 'post',
      data: data,
    })
  }

  exportBlacklist(data = {}) {
    return $http({
      method: 'post',
      url: apiBase.exportBlacklist,
      data: data
    })
  }
}

function singleServer() {
  if (singleServerObject === null) {
    singleServerObject = new BlackServer()
  }
  return singleServerObject
}
export default singleServer()
